import { config } from 'application';
import { nipClient } from 'application/nip';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ITemplate } from 'types/dto';
import { handleDownloadFileResponse } from 'utils/net';

export async function fetchTemplatesList(): Promise<ITemplate[]> {
  return nipClient.get(config.nip.apiUrl + '/plans/types').then(
    res => res.data.data,
    err => console.error(err),
  );
}

export function useTemplatesList(options?: UseQueryOptions<ITemplate[]>) {
  return useQuery<ITemplate[]>(['templates'], fetchTemplatesList, options);
}

export async function fetchTemplateFileById(id: number): Promise<any> {
  return nipClient
    .get(`/plans/types/${id}/template`, {
      responseType: 'blob',
    })
    .then(
      res => {
        handleDownloadFileResponse(res, `plan${id}.xlsx`);
      },
      err => console.error(err),
    );
}
